module.exports = __webpack_public_path__ + "static/media/obrazac-za-identifikaciju.5607504d.png";